<template>
  <div class="book" :class="{ active: active }">
    <div class="book-inner" data-io-click="tracker"  @click.stop="selectBook">
      <span class="volume">{{ book.volume }}</span>
      <span class="subject">{{ book.subjectName }}</span>
      <span class="version">{{ book.versionName }}</span>
      <svg class="icon" aria-hidden="true">
        <use :xlink:href="'#' + bookBgList[index % 8]"></use>
      </svg>
      <span
        v-if="textbook.selectedTextbooks.length !== 1"
        class="delete"
        data-io-click="tracker"  @click.stop="deleteBook(book.bookId)"
      >
        <i class="iconfont icon-delete"></i>
        <span class="name">删除该教材</span>
      </span>
    </div>
  </div>
</template>
<script>
import { bookBgList } from "@/utils/stateList";
export default {
  props: {
    //是否选中
    active: {
      type: Boolean,
      default: false,
    },
    // 书籍详情
    book: {
      type: Object,
      default() {
        return {};
      },
    },
    // 索引
    index: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      //教材背景图列表
      bookBgList: bookBgList,
    };
  },
  inject: ["textbook"],
  methods: {
    selectBook() {
      this.$emit("selectBook", this.book);
    },
    async deleteBook(id) {
      await this.textbook.deleteTextbook(id);
      this.$emit("deleteBookCallback", id);
    },
  },
};
</script>
<style lang="scss" scoped>
.active {
  box-shadow: 0px 0px 6px 1px #91b7ff;
}
.book {
  display: inline-block;
  margin-bottom: 26px;
  vertical-align: top;
  width: 131px;
  .book-inner {
    position: relative;
    margin: 0 auto 0;
    width: 111px;
    height: 143px;
    border-radius: 0 6px 6px 0;
    cursor: pointer;
    &:hover {
      box-shadow: 0 2px 12px 0 rgb(0 0 0 / 10%);
      .delete {
        opacity: 1;
      }
    }
  }
  .icon {
    position: absolute;
    z-index: 1;
    bottom: 0;
    left: -22px;
    width: 156px;
    height: 143px;
  }
  .delete {
    position: absolute;
    width: 26px;
    height: 19px;
    z-index: 2;
    bottom: 0;
    right: 0;
    line-height: 19px;
    background: #fe4509;
    border-radius: 6px 0px 6px 0px;
    text-align: center;
    transition: all 0.4s;
    opacity: 0;
    .iconfont {
      opacity: 1;
      font-size: 12px;
      color: #fff;
    }
    .name {
      position: absolute;
      left: 0;
      right: 0;
      top: 0;
      opacity: 0;
      display: block;
      font-size: 12px;
      color: #fff;
    }
    &:hover {
      width: 100%;
      border-radius: 0 0px 6px 0px;
      .iconfont {
        opacity: 0;
      }
      .name {
        opacity: 1;
      }
    }
  }
  .volume,
  .subject,
  .version {
    position: absolute;
    z-index: 2;
    white-space: normal;
  }
  .volume {
    top: 9px;
    right: 9px;
    color: #333;
    font-size: 11px;
  }
  .subject {
    top: 53px;
    left: 0;
    width: 100%;
    height: 16px;
    text-align: center;
    font-size: 16px;
    font-weight: 500;
    color: #fff;
  }
  .version {
    top: 79px;
    left: 0;
    width: 100%;
    font-size: 10px;
    font-weight: 500;
    line-height: 1.3;
    text-align: center;
    color: #ffffff;
  }
}
</style>
